import { TermsAndPolicyV2 } from '@dealstack/frontend/shared/components/TermsAndPolicyV2/TermsAndPolicyV2';
import React, { memo } from 'react';

interface Props {
	children?: React.ReactNode;
	isInvestorApp?: boolean;
}

const AuthLayoutV2 = ({ isInvestorApp, children }: Props) => {
	return (
		<div className="mt-24 flex flex-col">
			<div className="self-center">{children}</div>
			<TermsAndPolicyV2 isInvestorApp={isInvestorApp} />
		</div>
	);
};
const _AuthLayoutV2Export = memo(AuthLayoutV2);

export { _AuthLayoutV2Export as AuthLayoutV2 };
